import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ListTenantSpeedDialsVm } from '../models';
import { environment } from '../../../environments/environment';
import { map, shareReplay } from 'rxjs/operators';
import { shareReplayRefCount } from '@adreno-common';

@Injectable({
  providedIn: 'root',
})
export class SpeedDialsService {
  private speedDialsApi = `${environment.apiPath}/speedDials`;

  speeddials$ = this.http
    .get<ListTenantSpeedDialsVm>(`${this.speedDialsApi}`)
    .pipe(
      map((vm) => vm.speedDials),
      shareReplayRefCount()
    );

  constructor(private http: HttpClient) {}

  requerySpeedDials(filtertext: string) {
    this.speeddials$ = this.http
      .get<ListTenantSpeedDialsVm>(`${this.speedDialsApi}`)
      .pipe(
        map((vm) =>
          vm.speedDials.filter(
            (sd) =>
              sd.name.toLowerCase().includes(filtertext.toLowerCase()) ||
              sd.number.includes(filtertext)
          )
        ),
        shareReplayRefCount()
      );
  }
}
